/***** 详情页组件 *****/
export const BOOK_DETAIL = 'BOOK_DETAIL';         // 图书详情
export const PRODB_BOOK_DETAIL = 'PRODB_BOOK_DETAIL';//prodb图书详情
export const CART_NUMS = 'CART_NUMS';             // 购物车信息
export const COLLECT_OR_LIKE = 'COLLECT_OR_LIKE'; // 加入收藏
export const BOOK_INTRODUCTION = 'BOOK_INTRODUCTION'; //图书简介
export const QUERY_EBOOK = 'QUERY_EBOOK';
export const CANCEL_HISTORY = 'CANCEL_HISTORY'; //取消历史记录
export const HISTORY_RECODE = 'HISTORY_RECODE'; //历史记录
export const HOT_SALE = 'HOT_SALE'; //热卖图书
export const ADD_CART = 'ADD_CART';
/***** END 详情页组件 *****/



// WEBPACK FOOTER //
// ./src/components/work/bookDetail/common/interfaces.js